import { noop } from 'lodash';
import { Action } from '../../shared/models/action.model';
import { updateAction } from '../../utils/utility';
import actionTypes from '../types/idCardTypes';

export const saveNumber = ({payload, onSuccess = noop, onError = noop, submitUrl}: any): Action<any> => {
  return  { type: actionTypes.SAVE_NUMBER, ...{ onSuccess, payload, onError, submitUrl } };
};

export const saveAdhaarNumber = ({payload, onSuccess = noop, onError = noop, submitUrl}: any): Action<any> => {
  return  { type: actionTypes.SAVE_ADHAAR_NUMBER, ...{ onSuccess, payload, onError, submitUrl } };
};

export const savePhrAddress = ({payload, onSuccess = noop, onError = noop, submitUrl}: any): Action<any> => {
  return  { type: actionTypes.SAVE_PHR_ADDRESS, ...{ onSuccess, payload, onError, submitUrl } };
};

export const setTransactionID = (payload: any): any => updateAction(actionTypes.TRANSACTION_ID, payload);

export const setToken = (payload: any): any => updateAction(actionTypes.TOKEN, payload);

export const setIdCardInfo = (payload: any): any => updateAction(actionTypes.ID_CARD_INFO, payload);

export const setUserInfo = (payload: any): any => updateAction(actionTypes.USER_INFO, payload);

export const setDownloadIdCardInfo = (payload: any): any => updateAction(actionTypes.DOWNLOAD_IDCARD_INFO, payload);

export const setCertificateInfo = (payload: any): any => updateAction(actionTypes.CERIFICATE, payload);

export const setCheckHealthIdCallback = (payload: any): any => updateAction(actionTypes.SET_CALLBACK, payload);

export const confirmOTPAndFetchInfo = ({payload, onSuccess = noop, onError = noop, submitUrl}: any): Action<any> => {
  return  { type: actionTypes.CONFIRM_OTP_AND_FETCH_INFO, ...{ onSuccess, payload, onError, submitUrl } };
};

export const confirmOTP = ({payload, onSuccess = noop, onError = noop, submitUrl}: any): Action<any> => {
  return  { type: actionTypes.CONFIRM_OTP, ...{ onSuccess, payload, onError, submitUrl } };
};

export const confirmAdhaarOTP = ({payload, onSuccess = noop, onError = noop, submitUrl}: any): Action<any> => {
  return  { type: actionTypes.CONFIRM_ADHAAR_OTP, ...{ onSuccess, payload, onError, submitUrl } };
};

 export const fetchCard = ({payload, onSuccess = noop, onError = noop, submitUrl}: any): Action<any> => {
  return  { type: actionTypes.FETCH_CARD, ...{ onSuccess, payload, onError, submitUrl } };
};

export const fetchCowinCert = ({payload, onSuccess = noop, onError = noop, submitUrl}: any): Action<any> => {
  return  { type: actionTypes.GET_CERTIFICATE, ...{ onSuccess, payload, onError, submitUrl } };
};

export const resetIdCardState = (): any => updateAction(actionTypes.RESET_ID_CARD_STATE);
